import React from "react";

const AnimatedWord = ({ word, minimumDelay, index }) => {

    const delay = index === 0 ? minimumDelay : minimumDelay + (index * 0.2) / (index+1)
  return (
    <span
      className="inline-block opacity-0 animate-slide-fade-in"
      style={{
        animationDelay: `${delay}s`,
        animationDuration: "0.5s",
        animationFillMode: "forwards",
      }}
    >
      {word}
      {word.includes(" ") ? "\u00A0" : ""}
    </span>
  );
};

export default AnimatedWord;